<template>
  <div :id="'oppwa-cc-container-' + _uid">
    <div class="text_top">
      <slot name="txtBefore"></slot>
    </div>

    <form :action="_redirectUrl" class="paymentWidgets" :data-brands="availableCreditCards" :id="token" :target="target"></form>
    <div class="text_bottom">
      <slot name="txtAfter"></slot>
    </div>
  </div>
</template>

<script>

const urlParameters = new URLSearchParams(window.location.search)

export default {
  name: 'OppwaCC',
  mounted () {
    this.initCC()
  },
  created () {
    try {
      this.decodedExtra = JSON.parse(atob(this.extra))
    } catch (e) {
      this.decodedExtra = {}
    }
  },
  computed: {
    oppwaUrl: function () {
      return this.oppwaBaseUrl + this.token
    },
    // it seems that this must be on the some domain as the referer
    _redirectUrl: function () {
      if (this.redirectUrl) {
        return this.redirectUrl
      }
      return window.location.href
    },
    configScriptId: function () {
      return 'oppwa-cc-config-' + this._uid
    },
    oppwaScriptId: function () {
      return 'oppwa-cc-script-' + this._uid
    },
    extraData () {
      return this.decodedExtra
    },
    frameStyles () {
      if (this.decodedExtra.iframeStyles) {
        return this.decodedExtra.iframeStyles
      }
      return {
        'cc-number': {
          'background-color': '#fbfbfb',
          border: '2px solid #e6e6e6',
          'border-radius': '5px',
          height: '25px',
          'font-size': '16px',
          padding: '0 3px',
          width: '431px'
        },
        cvv: {
          'background-color': '#fbfbfb',
          border: '2px solid #e6e6e6',
          'border-radius': '5px',
          height: '25px',
          'font-size': '16px',
          padding: '0 3px',
          width: '431px'
        }
      }
    },
    labels () {
      if (this.decodedExtra.labels) {
        return this.decodedExtra.labels
      }
      return {}
    }
  },
  methods: {
    removeOldScripts () {
      const configScript = document.getElementById(this.configScriptId)
      if (configScript !== null) {
        configScript.remove()
      }
      const oppwaScript = document.getElementById(this.oppwaScriptId)
      if (oppwaScript !== null) {
        oppwaScript.remove()
      }
    },
    initCC () {
      this.removeOldScripts()
      const ccContainer = document.getElementById('oppwa-cc-container-' + this._uid)
      const configScript = document.createElement('script')
      configScript.id = this.configScriptId
      const insertScript = document.createElement('script')
      insertScript.id = this.oppwaScriptId
      /* eslint-disable */
      const configScriptContent = `
function validateHolder (event) {
  const cardHolderInput = document.getElementsByClassName('wpwl-control-cardHolder').item(0)
  const cardHolderValue = cardHolderInput.value
  if (cardHolderValue.trim().length < 2) {
    if (!cardHolderInput.classList.contains('wpwl-has-error')) {
      cardHolderInput.classList.add('wpwl-has-error')
      cardHolderInput.insertAdjacentHTML('afterend', '<div class="wpwl-hint wpwl-hint-cardHolderError">Ungültiger Karteninhaber</div>')
    }
    event.preventDefault()
    event.stopPropagation()
    return false
  }
  return true
};
const wpwl = wpwlOptions =  {
    locale: 'de',
    style: 'plain',
    paymentTarget: '${this.target}',
    shopperResultTarget: '_top',
    shopperResultUrl: '${this.redirectUrl}',
    iframeStyles: ${JSON.stringify(this.frameStyles)},
    labels: ${JSON.stringify((this.labels))},
    onReady: function (event) {
      document.getElementsByClassName('wpwl-form-card')
        .item(0).getElementsByClassName('wpwl-button-pay')
        .item(0).addEventListener('click', function (event) {
          validateHolder(event)
        })
      document.getElementsByClassName('wpwl-container-card')
        .item(0).style.display = 'block'
    },
    onBeforeSubmitCard: function (event) {
      return validateHolder(event)
    },
    onError: function(error) {
      window.top.console.log(error.message);
      window.parent.top.dispatchEvent(new CustomEvent('oppwaError', error));
      // check if shopper payed after 30 minutes aka checkoutid is invalid
      if (error.name === "InvalidCheckoutIdError") {
        alert(JSON.stringify(error))
      } else if (error.name === "WidgetError") {
        console.log("here we have extra properties: ");
        console.log(error.brand + " and " + error.event);
      }
      // read the error message
      console.log(error.message);
    }
}
`
      configScript.text = configScriptContent
      insertScript.src = this.oppwaUrl
      if (typeof wpwlOptions === 'undefined') {
        // configuration wurde noch nicht injected
        ccContainer.insertAdjacentElement('afterbegin', configScript)
      }
      ccContainer.insertAdjacentElement('afterbegin', insertScript)
      /* eslint-enable */
    }
  },
  props: {
    oppwaBaseUrl: {
      type: String,
      default: function () {
        if (urlParameters.has('oppwaBaseUrl')) {
          return urlParameters.get('oppwaBaseUrl')
        }
        return process.env.VUE_APP_OPPWA_BASE_URL || 'https://test.oppwa.com/v1/paymentWidgets.js?checkoutId='
      }
    },
    target: {
      type: String,
      default: function () {
        if (urlParameters.has('target')) {
          return urlParameters.get('target')
        }
        return '_self'
      }
    },
    availableCreditCards: {
      type: String,
      default: 'MASTER VISA'
    },
    redirectUrl: {
      type: String,
      default: function () {
        if (urlParameters.has('redirectUrl')) {
          return urlParameters.get('redirectUrl')
        }
        const loc = window.location
        return loc.origin + loc.pathname
      }
    },
    token: {
      type: String,
      default: function () {
        if (urlParameters.has('token')) {
          return urlParameters.get('token')
        }
      }
    },
    extra: {
      type: String
    }
  }
}
</script>
